import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=504775f5"
import script from "./Side.vue?vue&type=script&lang=js"
export * from "./Side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports